import { render, staticRenderFns } from "./NotificationRuleIndex.vue?vue&type=template&id=05fc0499&scoped=true&"
import script from "./NotificationRuleIndex.vue?vue&type=script&lang=js&"
export * from "./NotificationRuleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc0499",
  null
  
)

export default component.exports